import * as React from "react";
import styled from "styled-components";

import { createEntitiesConsumer } from "../../lib/entities";
import { colors, media, truncateLines } from "../../common/utils/style";
import { User, Post, Profile } from "../../entities";
import Translate from "../../common/components/Translate";
import ImageContainer from "../../common/components/ImageContainer";

const PostEntitiesConsumer = createEntitiesConsumer<{
  post: Post;
}>({ post: "posts" });

interface Props {
  user: User;
  profile: Profile;
}

class MembershipProfilePost extends React.PureComponent<Props> {
  public render() {
    const { profile } = this.props;
    return <PostEntitiesConsumer query={{ post: profile.cover_post }}>{this.renderWithPost}</PostEntitiesConsumer>;
  }

  public renderWithPost: typeof PostEntitiesConsumer.children = ({ post }) => {
    if (!post) {
      return null;
    }
    const { user } = this.props;
    return (
      <CoverPost href={post.post_path}>
        {post.image && (
          <CoverPostImage namespace="companies" id={post.image} size="120x80#" alt={post.title} background />
        )}
        <CoverPostDetail>
          <CoverPostTitle>{post.title}</CoverPostTitle>
          <CoverPostHeadLine>
            <Translate id="company.members.story_of" values={{ name: user.name }} />
          </CoverPostHeadLine>
        </CoverPostDetail>
      </CoverPost>
    );
  };
}

const CoverPost = styled.a`
  min-height: 80px;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  border: solid 1px rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: flex-start;
  color: inherit;
  transition: opacity 0.2s ease-in-out;
  &:hover {
    text-decoration: none;
    opacity: 0.6;
  }
  @media ${media.medium} {
    padding: 10px;
    border-radius: 12px;
  }
`;

const CoverPostImage = styled(ImageContainer)`
  border-radius: 6px;
  height: 64px;
  width: 64px;
  min-width: 64px;
  background-size: cover;
  @media ${media.medium} {
    height: 80px;
    width: 120px;
  }
`;

const CoverPostDetail = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-left: 12px;
`;

const CoverPostHeadLine = styled.div`
  margin-top: 3px;
  font-weight: 600;
  font-size: 11px;
  color: ${colors.gray1};
  @media ${media.medium} {
    font-size: 12px;
  }
`;

const CoverPostTitle = styled.div`
  margin-top: 4px;
  font-weight: 600;
  color: ${colors.gray4};
  ${truncateLines(2, 13, 1.5)};
  @media ${media.medium} {
    white-space: normal;
    ${truncateLines(2, 16, 1.5)};
  }
`;

export default MembershipProfilePost;



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/components/MembershipProfilePost.tsx